/** Intl `en-MY` / MYR inserts a space after RM; live SFCC shows RM1234 (KINDW-658). */
const MYR_SYMBOL_SPACE = /^RM[\s\u00a0\u202f]+/u;

export function normalizeMyrCurrencyDisplay(formatted, currency) {
  if (currency !== 'MYR' || formatted == null) {
    return formatted ?? '';
  }

  return String(formatted).replace(MYR_SYMBOL_SPACE, 'RM');
}

/**
 * Currency for display: hide ".00" on whole-dollar amounts; show non-zero cents (e.g. .01).
 */
export function formatCurrencyHideTrailingZeroCents(intl, value, currency) {
  if (value == null || !Number.isFinite(Number(value))) {
    return '';
  }
  const n = Number(value);
  const cents = Math.round(Math.abs(n * 100)) % 100;
  const hasNonZeroCents = cents !== 0;
  const formatted = intl.formatNumber(n, {
    style: 'currency',
    currency,
    minimumFractionDigits: hasNonZeroCents ? 2 : 0,
    maximumFractionDigits: hasNonZeroCents ? 2 : 0,
  });

  return normalizeMyrCurrencyDisplay(formatted, currency);
}

/** Full precision currency string for aria-label / screen readers */
export function formatCurrencyFullPrecision(intl, value, currency) {
  if (value == null || !Number.isFinite(Number(value))) {
    return '';
  }
  const formatted = intl.formatNumber(Number(value), {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return normalizeMyrCurrencyDisplay(formatted, currency);
}
